import { createSlice } from '@reduxjs/toolkit';

const authenticatedUserSlice = createSlice({
  name: 'authenticated-user',
  initialState: null,
  reducers: {
    setAuthenticatedUser: (state, action) => {
      return action.payload;
    },
    userLogout: () => {
      return null;
    },
    updateUser: (state, action) => {
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    },
    updateNestedUserField: (state, action) => {
      if (!state) return;
      const { path, value } = action.payload;
      const keys = path.split(".");
      let nested = state;

      for (let i = 0; i < keys.length - 1; i++) {
        if (!nested[keys[i]]) nested[keys[i]] = {}; // Ensure path exists
        nested = nested[keys[i]];
      }

      nested[keys[keys.length - 1]] = value;
    },
  },
});

export const { setAuthenticatedUser, userLogout, updateUser, updateNestedUserField } = authenticatedUserSlice.actions;
export default authenticatedUserSlice.reducer;
